import React from 'react';
import { BrowserRouter as Router, Route, Switch, } from 'react-router-dom';
import {
  Message,
  Segment,
  Container,
} from 'semantic-ui-react';
import * as AuthComponents from '../auth';

const NoMatch = () => (
  <Container>
    <Segment>
      <Message
        negative
        icon="exclamation"
        size="huge"
        header="404"
        content="Not Found"
      />
    </Segment>
  </Container>
);

const LoggedOutContainer = (props) => {
  const { onLogin } = props;

  return (
    <Router>
      <div className="auth">
        <Switch>
          <Route
            exact
            path="/dealer/"
            render={() => <AuthComponents.Login onLogin={props.onLogin} />}
          />
          <Route path="/dealer/forgot-password" component={AuthComponents.ForgotPassword} />
          <Route path="/dealer/password-reset/:code" component={AuthComponents.ResetPassword} />
          <Route
            path="/dealer/password-create/:code"
            render={props => <AuthComponents.CreatePassword code={props.match.params.code} onLogin={onLogin} />}
          />
          <Route component={NoMatch} />
        </Switch>
      </div>
    </Router>
  );
};

export default LoggedOutContainer;


